﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const clients_1 = require("./clients");
class OperationalContextClientFactory {
}
exports.OperationalContextClientFactory = OperationalContextClientFactory;
OperationalContextClientFactory.getPluginClient = () => {
    return new clients_1.PluginClient();
};
OperationalContextClientFactory.getAuthorityClient = () => {
    return new clients_1.AuthorityClient();
};
OperationalContextClientFactory.getOperatorClient = () => {
    return new clients_1.OperatorClient();
};
OperationalContextClientFactory.getDepartmentClient = () => {
    return new clients_1.DepartmentClient();
};
OperationalContextClientFactory.getTimeZoneClient = () => {
    return new clients_1.TimeZoneClient();
};
OperationalContextClientFactory.getResourceClient = () => {
    return new clients_1.ResourceClient();
};
OperationalContextClientFactory.getUserClient = () => {
    return new clients_1.UserClient();
};
OperationalContextClientFactory.getExtendedAttributeClient = (baseUrl) => {
    return new clients_1.ExtendedAttributeClient(baseUrl);
};
OperationalContextClientFactory.getDriverClient = () => {
    return new clients_1.DriverClient();
};
OperationalContextClientFactory.getRoleClient = () => {
    return new clients_1.RoleClient();
};
OperationalContextClientFactory.getProfileClient = () => {
    return new clients_1.ProfileClient();
};
OperationalContextClientFactory.getLoginClient = () => {
    return new clients_1.LoginClient();
};
OperationalContextClientFactory.getSettingsClient = () => {
    return new clients_1.SettingClient();
};
OperationalContextClientFactory.getVehicleClient = () => {
    return new clients_1.VehicleClient();
};
OperationalContextClientFactory.getVehicleSharingClient = () => {
    return new clients_1.VehicleSharingClient();
};
OperationalContextClientFactory.getVehicleAssignmentClient = () => {
    return new clients_1.VehicleAssignmentClient();
};
//# sourceMappingURL=OperationalContextClientFactory.js.map